import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import { ACTIVITY_TYPE } from '../../../const';
import * as bookActions from '../../../actions/bookActions';
import { ANALYTICS_CONTEXT } from '../../../types/analytics';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class DeleteActivityReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.closeModal = this.closeModal.bind(this);
    this.handleDeleteActivity = this.handleDeleteActivity.bind(this);
  }

  static propTypes = {
    activity: PropTypes.object,
    idBook: PropTypes.string,
    idClassroom: PropTypes.string
  };

  closeModal() {
    const { bookActions } = this.props;
    bookActions.setDeleteActivityData();
  }

  handleDeleteActivity() {
    const { bookActions, idClassroom, idBook, activity } = this.props;
    let context = null;
    if (activity) {
      if (activity.type === ACTIVITY_TYPE.LESSON) {
        context = ANALYTICS_CONTEXT.LESSON_DELETE;
      } else if (activity.type === ACTIVITY_TYPE.UNIT) {
        context = ANALYTICS_CONTEXT.UNIT_DELETE;
      }
    }
    bookActions.deleteActivity(idBook, idClassroom, activity.activityId, context).then(() => {
      this.closeModal();
    });
  }

  render() {
    const { activity } = this.props;

    let disclaimerMsg = '';
    let titleMsg = '';
    if (activity) {
      switch (activity.type) {
        case ACTIVITY_TYPE.UNIT:
          disclaimerMsg = 'unitCard.delete.disclaimer';
          titleMsg = 'unitCard.delete.unit';
          break;
        case ACTIVITY_TYPE.LESSON:
          disclaimerMsg = 'lessonCard.delete.disclaimer';
          titleMsg = 'lessonCard.delete.lesson';
          break;
        default:
          break;
      }
    }

    return (
      <Modal
        id="archive-classroom"
        title={I18n.t(titleMsg)}
        active={!!activity}
        onClickOutside={this.closeModal}
        children={
          <Paragraph className="text-grey-700">
            {I18n.t(disclaimerMsg)} {I18n.t('common.uSure')}
          </Paragraph>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.handleDeleteActivity} btnDanger label={I18n.t('common.delete')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    activity: state.book.deleteActivityReveal,
    i18n: state.i18n,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteActivityReveal);
